var TYPE = "INTL_CHANGED";

/** Message for when window.meta.intl has changed */

export var isIntlChangedMessage = function isIntlChangedMessage(m) {
  return (m === null || m === void 0 ? void 0 : m.type) === TYPE;
};
export var intlChangedMessage = function intlChangedMessage() {
  return {
    type: TYPE,
    payload: null
  };
};